"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCodeCitationPropertyMismatchError = exports.ClauseCitationPropertyMismatchError = void 0;
exports.isClauseCitationPropertyMismatchError = isClauseCitationPropertyMismatchError;
exports.isErrorCodeCitationPropertyMismatchError = isErrorCodeCitationPropertyMismatchError;
class ClauseCitationPropertyMismatchError extends Error {
    constructor(clauseId, clausePropertyKey, addressPropertyKey) {
        super(`Clause ${clauseId} governs '${clausePropertyKey}' and cannot be cited on ` +
            `'${addressPropertyKey}' data. Pick a clause from the property being reviewed.`);
        this.name = this.constructor.name;
        this.clauseId = clauseId;
        this.clausePropertyKey = clausePropertyKey;
        this.addressPropertyKey = addressPropertyKey;
    }
}
exports.ClauseCitationPropertyMismatchError = ClauseCitationPropertyMismatchError;
function isClauseCitationPropertyMismatchError(error) {
    return error instanceof ClauseCitationPropertyMismatchError;
}
class ErrorCodeCitationPropertyMismatchError extends Error {
    constructor(errorCodeId, errorCodePropertyKey, addressPropertyKey) {
        super(`Error code ${errorCodeId} belongs to '${errorCodePropertyKey}' and cannot tag ` +
            `'${addressPropertyKey}' data. Pick a code from the property being reviewed.`);
        this.name = this.constructor.name;
        this.errorCodeId = errorCodeId;
        this.errorCodePropertyKey = errorCodePropertyKey;
        this.addressPropertyKey = addressPropertyKey;
    }
}
exports.ErrorCodeCitationPropertyMismatchError = ErrorCodeCitationPropertyMismatchError;
function isErrorCodeCitationPropertyMismatchError(error) {
    return error instanceof ErrorCodeCitationPropertyMismatchError;
}
//# sourceMappingURL=package-data-adjudication.errors.js.map